class WishlistUtils {

    static get wishlistId() {    
        const cookies = decodeURIComponent(document.cookie).split(";");
        const cookieString = "wishlist_id=";

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();

            if (cookie.indexOf(cookieString) === 0) {
            return cookie.substring(cookieString.length);
            }
        }

        return null;
    }

    static async retrieveWishlist() {
        if ( this.wishlist )
          return this.wishlist;

        const response = await fetch(
            `/a/wishlist?type=api&wishlistid=${WishlistUtils.wishlistId}&version=1`,
            {
                method: "GET",
                cache: "no-store",
            }
        );
        const data = await response.json();
        const items = data.items;

        localStorage.setItem('wishlist', JSON.stringify(items));

        return items;
    }
    
    static get wishlist() {
        const wishlistObj = localStorage.getItem('wishlist');
        return wishlistObj && JSON.parse(wishlistObj);
    }

    static removeFromSmartWishlist(product) {
        RemoveFromSmartWishlist(product.id, product.variant_id);
        let wishlist = this.wishlist;
        if (!wishlist )
            return;

        wishlist = wishlist.filter(item => item.id !== product.id || item.variant_id !== product.variant_id);
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
    }

    static addToSmartWishlist(product) {
        AddToSmartWishlist(product.id, product.variant_id);
        let wishlist = WishlistUtils.wishlist;
        if (!wishlist )
          return;

        wishlist.push(product);
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
    }

    static isInWishlist(product) {
        let wishlist = WishlistUtils.wishlist;
        if (!wishlist)
            return false;
        
        return wishlist.find(item => item.id === product.id && item.variant_id === product.variant_id);
    }

}


class CustomWishlist extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadWishlist();
    this.onWishlistChange = subscribe(
        PUB_SUB_EVENTS.wishlistChange,
        () => {this.loadWishlist();}
    );
  }

  disconnectedCallback() {
    this.onWishlistChange && this.onWishlistChange()
  }

  loadWishlist() {
    const items = WishlistUtils.wishlist;
    if (items.length) this.renderItems(items);
  }

  async renderItems(items) {
    const rootUrl = window.routes.root_url || "";
    let fetchPromises = [];
    
    while (items.length) {  
      let request = "";
      for (let item of items.splice(0, 10)) request += "&wish=" + item.handle;
      const batchPromise = fetch(`${location.origin + rootUrl}/search?view=wishlist-grid${request}`).then(response => response.text());  
      fetchPromises.push(batchPromise);
    }

    const responses = await Promise.all(fetchPromises);
    let result = "";
    for (let responseText of responses) {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      result += html.querySelector('ul').innerHTML;
    } 

    this.querySelector('.collection-grid').innerHTML = result;
    
  }
}
customElements.define("custom-wishlist", CustomWishlist);

class WishlistButton extends HTMLElement {
  constructor() {
    super();
  }

  get isRemove() {
    return this.querySelector('.svg-wrapper').classList.contains('full');
  }

  get product() {
    return this.dataset.product;
  }

  get variant() {
    return this.dataset.variant;
  }

  get handle() {
    return this.dataset.handle;
  }

  get item() {
    return {
        id:this.product, 
        variant_id:this.variant, 
        handle:this.handle
    }
  }

  connectedCallback() {
    this.setStyle();
    this.addEventListener('click', (event) => {
        this.isRemove ?  WishlistUtils.removeFromSmartWishlist(this.item) :   WishlistUtils.addToSmartWishlist(this.item)

        this.setStyle();
        publish(PUB_SUB_EVENTS.wishlistChange);

    });
  }

  setStyle() {
    const isInWishlist = WishlistUtils.isInWishlist(this.item);
    
    const svg = this.querySelector('.svg-wrapper');

    this.querySelector('button').setAttribute('aria-pressed', isInWishlist);

    let [add, remove] = isInWishlist ? ['full', 'empty'] : ['empty', 'full' ];
    svg.classList.add(add);
    svg.classList.remove(remove);
  }

}

customElements.define("wishlist-button", WishlistButton);

class WishlistIcon extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadIcon();
    this.onWishlistChange = subscribe(
        PUB_SUB_EVENTS.wishlistChange,
        () => {this.loadIcon()}
    );
  }

  disconnectedCallback() {
    this.onWishlistChange && this.onWishlistChange()
  }

  async loadIcon() {
    const wishlist = await WishlistUtils.retrieveWishlist();
    const size = wishlist.length || 0;

    this.querySelector('[data-bubble]').classList.toggle('!tw-hidden', size === 0);
    this.querySelector('[data-count]').innerHTML = size;
  }

}


customElements.define("wishlist-icon", WishlistIcon);